<template>
  <div class="user">
    开发中！
    <!-- <transition name="slide-fade">
      <div class="main" v-show="web == 'main'">
        <div class="title">开票信息</div>
        <el-form class="search-form" ref="form" :model="searchForm" label-width="80px">
          <el-row>
            <el-col :xs="24" :sm="10">
              <el-form-item label="公司名称" :label-width="'120px'">
                <el-input size="small" v-model="searchForm.payer" placeholder="请输入付款方公司名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="状态">
                <el-select v-model="searchForm.state" placeholder="请选择状态" clearable>
                  <el-option v-for="(item, index) in invoiceState" :key="index" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item class="btn">
                <el-button type="primary" size="small" class="search" @click="search">查询
                </el-button>
                <el-button type="primary" size="small" class="search" @click="add">新增
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table class="show-pc" :data="tableData" height="61vh" style="width: 100%">
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              <span>{{ scope.row.payer }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司税号">
            <template slot-scope="scope">
              <span>{{ scope.row.payerTaxNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <span>{{ scope.row.address }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开票项目">
            <template slot-scope="scope">
              <span>{{ scope.row.serviceProject }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-for="(item, index) in invoiceState" :key="index"
                v-show="scope.row.state === item.name">{{item.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-show="scope.row.state === '退回'" size="mini" type="primary" plain
                @click="reAdd(scope.row)">重新提交</el-button>
              <el-button size="mini" type="primary" plain
                @click="detail(scope.$index, scope.row)">详细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="show-phone" :data="tableData" height="61vh" style="width: 100%">
          <el-table-column label="开票信息">
            <template slot-scope="scope">
              <div>公司名称：{{ scope.row.payer }}</div>
              <div>公司税号：{{ scope.row.payerTaxNum }}</div>
              <div>地址：{{ scope.row.address }}</div>
              <div>联系电话：{{ scope.row.phone }}</div>
              <div>开票项目：{{ scope.row.serviceProject }}</div>
              <div>
                状态：<span v-for="(item, index) in invoiceState" :key="index"
                  v-show="scope.row.state === item.name">{{item.name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
              <el-button v-show="scope.row.state === '退回'" size="mini" type="primary" plain
                @click="reAdd(scope.row)">重新提交</el-button>
              <br v-show="scope.row.state === '退回'" />
              <br v-show="scope.row.state === '退回'" />
              <el-button size="mini" type="primary" plain
                @click="detail(scope.$index, scope.row)">详细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page show-pc">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[100, 200, 500, 1000, 2000]" :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper" :total="total">
          </el-pagination>
        </div>
        <div class="page show-phone">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="edit" v-show="web == 'edit' || web == 'add' || web == 'detail' ">
        <div class="title">{{web == 'edit'?'编辑': '新增'}}</div>
        <div class="el-form" label-position="top">
          <table class="detail">
            <tr>
              <td>公司名称: {{addForm.payer}}</td>
              <td>公司税号: {{addForm.payerTaxNum}}</td>
            </tr>
            <tr>
              <td>地址: {{addForm.address}}</td>
              <td>联系电话: {{addForm.phone}}</td>
            </tr>
            <tr>
              <td>银行: {{addForm.blank}}</td>
              <td>银行账号: {{addForm.blankAccount}}</td>
            </tr>
            <tr>
              <td>开票项目: {{addForm.serviceProject}}</td>
              <td>状态: <span v-for="(item, index) in invoiceState" :key="index"
                  v-show="addForm.state === item.name">{{item.name}}</span>
              </td>
            </tr>
            <tr>
              <td>规格型号: {{addForm.model}}</td>
              <td>数量: {{addForm.number}}</td>
            </tr>
            <tr>
              <td>单价: {{addForm.price}}</td>
              <td>总金额: {{addForm.total}}</td>
            </tr>
            <tr>
              <td>收件人: {{addForm.addressee}}</td>
              <td>收件人联系电话: {{addForm.recipientPhone}}</td>
            </tr>
            <tr>
              <td colspan="2">收件人地址: {{addForm.recipientAddress}}</td>
            </tr>
            <tr>
              <td colspan="2">备注: {{addForm.price}}</td>
            </tr>
            <tr>
              <td colspan="2">
                <el-button type="primary" size="small" plain class="cancel"
                  @click="cancel">返回列表</el-button>
              </td>
            </tr>
          </table>

          <div v-show="web == 'add' || web == 'edit'">
            <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules">
              <el-form-item label="公司名称" prop="payer">
                <el-input v-model="addForm.payer"></el-input>
              </el-form-item>
              <el-form-item label="公司税号" prop="payerTaxNum">
                <el-input v-model="addForm.payerTaxNum"></el-input>
              </el-form-item>
              <el-form-item label="地址">
                <el-input v-model="addForm.address"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="addForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="银行">
                <el-input v-model="addForm.blank"></el-input>
              </el-form-item>
              <el-form-item label="银行账号">
                <el-input v-model="addForm.blankAccount"></el-input>
              </el-form-item>
              <el-form-item label="开票项目">
                <el-input v-model="addForm.serviceProject"></el-input>
              </el-form-item>
              <el-form-item label="规格型号">
                <el-input v-model="addForm.model"></el-input>
              </el-form-item>
              <el-form-item label="数量">
                <el-input type="number" :min="0" v-model="addForm.number"></el-input>
              </el-form-item>
              <el-form-item label="单价">
                <el-input type="number" :min="0" v-model="addForm.price"></el-input>
              </el-form-item>
              <el-form-item label="总金额">
                <el-input type="number" :min="0" v-model="addForm.total"></el-input>
              </el-form-item>
              <el-form-item label="收件人">
                <el-input v-model="addForm.addressee"></el-input>
              </el-form-item>
              <el-form-item label="收件人联系电话">
                <el-input type="number" v-model="addForm.recipientPhone"></el-input>
              </el-form-item>
              <el-form-item label="收件人地址">
                <el-input v-model="addForm.recipientAddress"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="addForm.remark"></el-input>
              </el-form-item>
              <el-button v-show="!addForm.id" type="primary" size="small"
                @click="addInvoice">保存
              </el-button>
              <el-button v-show="addForm.id" type="primary" size="small"
                @click="reAddInvoice">保存
              </el-button>
              <el-button type="primary" size="small" plain class="cancel"
                @click="cancel">返回列表</el-button>
            </el-form>
          </div>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
// import selfTitle from '../components/Title'
export default {
  name: 'User',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['开票信息'],
      web: 'main',
      searchForm: {
        payer: '',
        state: ''
      },
      addForm: {
        payer: '', // 公司名称
        payerTaxNum: '', // 公司税号
        address: '', // 地址
        phone: '', // 电话
        blank: '', // 银行
        blankAccount: '', // 银行账号
        serviceProject: '', // 开票项目
        model: '', // 规格型号
        number: '', // 数量
        price: '', // 单价
        total: '', // 总金额
        remark: '', // 备注
        addressee: '', // 收件人
        recipientAddress: '', // 收件人地址
        recipientPhone: '' // 收件人手机号
      },
      checkForm: {
        state: '',
        backReason: '' // 退回原因
      },
      invoiceState: [], // 开票信息状态
      menus: [],
      tableData: [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      rules: {
        payer: [{ type: 'string', required: true, message: '请输入公司名称', trigger: 'blur' }],
        payerTaxNum: [{ type: 'string', required: true, message: '请输入公司税号', trigger: 'blur' }]
      }
    }
  },
  methods: {
    titleClick(item, index) {
      console.log(item, index)
      if (item === '开票信息') {
        this.web = 'main'
        this.titles = ['开票信息'] // 导航菜单
      }
    },
    search() {
      // 查询
      this.queryInvoice()
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
      开票信息状态
      system/code/query?systemId=0&businessId=6
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.circles = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            } else if (businessId === 6) {
              this.invoiceState = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增点击
    add() {
      this.web = 'add'
      this.titles = ['开票信息', '新增']
      setTimeout(() => {
        this.$refs.addForm.clearValidate()
      }, 0)
    }, // 新增
    // 重新提交点击
    reAdd(data) {
      console.log(data)
      this.web = 'edit'
      if (data) {
        this.addForm = data
      }
      this.addForm.id = 6
      this.titles = ['开票信息', '重新提交']
      setTimeout(() => {
        this.$refs.addForm.clearValidate()
      }, 0)
    }, // 新增
    // 详情查看
    detail(data) {
      this.web = 'detail'
      this.titles = ['开票信息', '详情']
      setTimeout(() => {
        this.$refs.addForm.clearValidate()
      }, 0)
    }, // 新增
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.search()
    },
    cancel() {
      this.checkForm = {
        state: '',
        backReason: '' // 退回原因
      }
      this.web = 'main'
      this.titles = ['开票信息']
    },
    // 查询开票信息列表
    queryInvoice() {
      const param = {
        payer: this.searchForm.payer,
        state: this.searchForm.state,
        page: this.currentPage,
        limit: this.pageSize
      }
      this.$post('/invoice/wechat/query', param).then(
        result => {
          if (result.status === 200) {
            this.total = result.count
            this.tableData = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询开票信息列表
    addInvoice() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const param = {
            payer: this.addForm.payer, // 公司名称
            payerTaxNum: this.addForm.payerTaxNum, // 公司税号
            address: this.addForm.address, // 地址
            phone: this.addForm.phone, // 电话
            blank: this.addForm.blank, // 银行
            blankAccount: this.addForm.blankAccount, // 银行账号
            serviceProject: this.addForm.serviceProject, // 开票项目
            model: this.addForm.model, // 规格型号
            number: this.addForm.number, // 数量
            price: this.addForm.price, // 单价
            total: this.addForm.total, // 总金额
            remark: this.addForm.remark, // 备注
            addressee: this.addForm.addressee, // 收件人
            recipientAddress: this.addForm.recipientAddress, // 收件人地址
            recipientPhone: this.addForm.recipientAddress // 收件人手机号
          }
          this.$post('/invoice/add', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.cancel()
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          return this.$toast('请填写开票信息！')
        }
      })
    },
    // 查询开票信息列表
    reAddInvoice() {
      const param = {
        id: this.addForm.id, // id
        payer: this.addForm.payer, // 公司名称
        payerTaxNum: this.addForm.payerTaxNum, // 公司税号
        address: this.addForm.address, // 地址
        phone: this.addForm.phone, // 电话
        blank: this.addForm.blank, // 银行
        blankAccount: this.addForm.blankAccount, // 银行账号
        serviceProject: this.addForm.serviceProject, // 开票项目
        model: this.addForm.model, // 规格型号
        number: this.addForm.number, // 数量
        price: this.addForm.price, // 单价
        total: this.addForm.total, // 总金额
        remark: this.addForm.remark, // 备注
        addressee: this.addForm.addressee, // 收件人
        recipientAddress: this.addForm.recipientAddress, // 收件人地址
        recipientPhone: this.addForm.recipientAddress // 收件人手机号
      }
      this.$post('/invoice/reAdd', param).then(
        result => {
          if (result.status === 200) {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            this.cancel()
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    }
  },
  mounted() {
    // if (this.$common.session.get('userInfo')) {
    //   this.userInfo = this.$common.session.get('userInfo')
    // } else {
    //   window.location.href = 'http://17l.link/dist/?id=1&targetName=Invoice&wechatLogin=true&state=123'
    //   return
    // }
    // this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=Invoice&wechatLogin=true&state=123')
    // this.queryInvoice()
    // this.queryCode(6)
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.user {
  padding: 2vh 2vw;
  box-sizing: border-box;
  .main {
    height: 100%;
  }
  .title {
    height: 3vh;
    line-height: 3vh;
    font-size: 1.5rem;
    margin-bottom: 1.4vh;
  }
  .detail {
    width: 100%;
    tr {
      td {
        padding: 8px;
      }
    }
  }
}
</style>
